import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PropertyService } from '../../services/property.service';

@Component({
  selector: 'app-archived-properties',
  templateUrl: './archived-properties.component.html',
  styleUrls: ['./archived-properties.component.scss']
})
export class ArchivedPropertiesComponent implements OnInit {
  archivedProperties: any[] = [];
  displayedColumns: string[] = ['address', 'city', 'state', 'archivedAt', 'actions'];
  loading = true;
  error: string | null = null;
  restoringId: string | null = null;

  constructor(
    private propertyService: PropertyService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadArchived();
  }

  private loadArchived() {
    this.loading = true;
    this.error = null;
    this.propertyService.getArchivedProperties()
      .then((properties: any[]) => {
        // Sort newest-archived first so the recent archive floats to the top.
        this.archivedProperties = (properties || []).slice().sort((a, b) => {
          const aDate = a && a.archivedAt ? new Date(a.archivedAt).getTime() : 0;
          const bDate = b && b.archivedAt ? new Date(b.archivedAt).getTime() : 0;
          return bDate - aDate;
        });
        this.loading = false;
      })
      .catch(err => {
        console.error('Failed to load archived properties:', err);
        this.error = (err && err.message) || 'Failed to load archived properties.';
        this.archivedProperties = [];
        this.loading = false;
      });
  }

  view(property: any) {
    if (!property || !property.id) return;
    // Reuse the standard read-only property page so all historical data
    // (statements, expenses, invoices, past leases) stays reachable.
    this.router.navigate(['view-property', property.id]);
  }

  restore(property: any) {
    if (!property || !property.id || this.restoringId) return;
    const label = property.addressLine1 || 'this property';
    if (!confirm(`Restore ${label}? It will show up in the dashboard and property pickers again.`)) {
      return;
    }
    this.restoringId = property.id;
    this.propertyService.unarchiveProperty(property)
      .then(() => {
        this.restoringId = null;
        this.loadArchived();
      })
      .catch(err => {
        console.error('Failed to restore property:', err);
        this.restoringId = null;
        alert((err && err.error && err.error.error) || 'Failed to restore property.');
      });
  }

  goToDashboard() {
    this.router.navigate(['/admin-landing']);
  }
}
